module.exports = __webpack_public_path__ + "img/guest.ae2c0e1b.png";